import { create } from 'zustand';

interface CostCentersUIState {
  periodo: string;
  periodoComparacion: string;
  centroCosto: string;
  cantidadMesesHistorico: number;
  searchQuery: string;

  setPeriodo: (value: string) => void;
  setPeriodoComparacion: (value: string) => void;
  setCentroCosto: (value: string) => void;
  setCantidadMesesHistorico: (value: number) => void;
  setSearchQuery: (value: string) => void;

  reset: () => void;
}

const initialState = {
  periodo: '',
  periodoComparacion: '',
  centroCosto: 'TODOS',
  cantidadMesesHistorico: 6,
  searchQuery: '',
};

export const useCostCentersUIStore = create<CostCentersUIState>((set) => ({
  ...initialState,

  setPeriodo: periodo => set({ periodo }),
  setPeriodoComparacion: periodoComparacion => set({ periodoComparacion }),
  setCentroCosto: centroCosto => set({ centroCosto }),
  setCantidadMesesHistorico: cantidadMesesHistorico => set({ cantidadMesesHistorico }),
  setSearchQuery: searchQuery => set({ searchQuery }),

  reset: () => set(initialState),
}));
